// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__7K8QEsQ+","tab":"Tabs_tab__ni80AU3m","active":"Tabs_active__qq4j2Hi2"};